export interface ApiErrorLike {
  status?: number;
  data?: { error?: string; code?: string; [key: string]: unknown };
  message?: string;
}

export function apiErrorMessage(err: unknown, fallback: string): string {
  const e = err as ApiErrorLike;
  if (e && typeof e === "object") {
    if (e.data?.error && typeof e.data.error === "string") return e.data.error;
    if (e.message) return e.message;
  }
  return fallback;
}

export function apiErrorStatus(err: unknown): number | undefined {
  const e = err as ApiErrorLike;
  return e?.status;
}

export interface RateLimitErrorData {
  remaining: number;
  max: number;
  resetAt: string;
}

export function apiErrorRateLimit(err: unknown): RateLimitErrorData | null {
  const e = err as ApiErrorLike;
  const data = e?.data;
  if (!data || typeof data !== "object") return null;
  const { remaining, max, resetAt } = data as Record<string, unknown>;
  if (
    typeof remaining === "number" &&
    typeof max === "number" &&
    typeof resetAt === "string"
  ) {
    return { remaining, max, resetAt };
  }
  return null;
}

export function apiErrorCode(err: unknown): string | undefined {
  const e = err as ApiErrorLike;
  if (e && typeof e === "object" && e.data && typeof e.data.code === "string") {
    return e.data.code;
  }
  return undefined;
}

export function apiErrorData<T = Record<string, unknown>>(
  err: unknown,
): T | undefined {
  const e = err as ApiErrorLike;
  if (e && typeof e === "object" && e.data && typeof e.data === "object") {
    return e.data as T;
  }
  return undefined;
}
